import React, { Component } from 'react';
import { connect } from 'shalala';

import { useStore } from '../../../store';
import Loading from '../../../facturotopia/loading/Loading';
import PageHeader from '../../../support/page-header/PageHeader';
import { Badge, Col, Row } from 'react-bootstrap';
import TipoComprobante from '../../comprobantes/support/enum/TipoComprobante';
import PrefacturaStatusBadge from './components/PrefacturaStatusBadge';
import PrefacturaGeneralInfo from './components/PrefacturaGeneralInfo';
import PrefacturasItemActions from './components/PrefacturasItemActions';

class PrefacturasInfo extends Component {

  state = {}

  constructor(props) {
    super(props);

    const { data = {}} = props.location.state || {};
    const { id } = this.props.match.params;

    this.state = {
      data: !!data.id ? { ...data } : { id }
    }
  }

  componentDidMount() {
    const { id } = this.state.data

    this.props.info(id);
  }

  render() {
    const { data = {}, busy } = this.props;

    if (busy) {
      return <Loading />
    }

    const tipo = TipoComprobante.search(data.tipo) || TipoComprobante.undefined()

    return (
      <>
        <PageHeader to="/app/prefacturas" text="Prefacturas" />

        <h5>
          { data.id }
        </h5>

        { !!data.id && (
          <div>

            <Row className="mt-3 mb-1">
              <Col xs={ 12 } sm={ 12 } md={ 8 } className="mb-2">
                <div className="d-inline-block mr-3">
                  <span className="text-muted">Tipo:</span>
                  <br/>
                  <Badge pill variant="info">
                    { tipo.getName() || '...' }
                  </Badge>
                </div>

                <div className="d-inline-block mr-3">
                  <span className="text-muted">Ambiente:</span>
                  <br/>
                  <Badge pill variant="warning">
                    { data.live !== undefined ? (data.live ? 'Producción' : 'Test') : '...' }
                  </Badge>
                </div>

                <div className="d-inline-block mr-3">
                  <span className="text-muted">Status:</span>
                  <br/>
                  <PrefacturaStatusBadge status={ data.status } />
                </div>
              </Col>

              <Col className="text-right">
                <PrefacturasItemActions
                  data={ data }
                />
              </Col>
            </Row>

            <div className="d-block mt-3 mb-2">
              <strong className="text-muted">Detalles</strong>
            </div>

            <PrefacturaGeneralInfo data={ data } />

          </div>
        )}
      </>
    );
  }
}

const mapState = (state) => {
  return state.app.prefacturas.info;
}

const mapActions = (actions) => {
  return actions.app.prefacturas.info;
}

export default connect(useStore, mapState, mapActions)(PrefacturasInfo);